
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, ServiceResponseModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TMCTableModule } from '@sdbn/appclient';
import { TransportWeighingsComponent } from './transport-weighings.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule
  ],
  declarations: [
    TransportWeighingsComponent
  ]
})
export class TransportWeighingsModule { }
